import {
  AccountTransactionChildWithDerivedStatuses,
  getMockTokenPrice,
  isUndecodedContractInteraction,
} from '@mls-wallet/shared-types';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { getContractDisplayName, getOpaqueContractDisplayName } from './utils';
import { TokenLogo } from '@/components/shared/token-logo';

interface TransactionTypeDisplayProps {
  transaction: AccountTransactionChildWithDerivedStatuses;
  variant?: 'cell' | 'detail';
  className?: string;
}

export function TransactionTypeDisplay({
  transaction,
  variant = 'cell',
  className = '',
}: TransactionTypeDisplayProps) {
  const detailClasses = variant === 'detail' ? 'text-base' : 'text-md';
  const iconSize = variant === 'detail' ? 'h-5 w-5' : 'h-4 w-4';
  const isOpaqueContractCall = isUndecodedContractInteraction(transaction);

  // Check if transaction has been executed
  const isExecuted = transaction.executionStatus === 'completed';

  // Get appropriate prefix for token transfers
  const getTokenTransferPrefix = () => {
    return isExecuted ? 'Sent' : 'Send';
  };

  // Get appropriate prefix for contract calls
  const getContractCallPrefix = () => {
    return 'Contract call';
  };

  {
    /* TODO: DEN-27 Delete when token price fetching is implemented */
  }
  getMockTokenPrice('');

  return (
    <div className={`flex items-start gap-2 ${className}`}>
      <div className="mt-0.5">
        <ArrowUpRight className={`${iconSize} text-rose-400`} />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        {transaction.type === 'TOKEN_TRANSFER' ? (
          <div>
            <span
              className={`inline-flex items-center gap-1 whitespace-nowrap text-base font-semibold leading-tight ${detailClasses}`}
            >
              {getTokenTransferPrefix()} {transaction.displayAmount}{' '}
              <TokenLogo
                symbol={transaction.asset.symbol}
                logoUrl={transaction.asset.logoUrl}
                size="sm"
              />
              {transaction.asset.symbol}
            </span>
            <span
              className={`font-normal text-muted-foreground whitespace-nowrap ${detailClasses}`}
            >
              {/*
              &nbsp;·&nbsp;$
              {(
                parseFloat(transaction.displayAmount) *
                getMockTokenPrice(transaction.asset.symbol)
              ).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} 
              */}
            </span>
          </div>
        ) : transaction.type === 'CONTRACT_INTERACTION' ? (
          <div className="flex min-w-0 flex-col items-start">
            <span className={`font-semibold text-base ${detailClasses}`}>
              {getContractCallPrefix()}
            </span>
            <span
              className={`flex min-w-0 max-w-full items-center text-muted-foreground ${detailClasses}`}
            >
              <span className="min-w-0 truncate font-normal text-sm">
                {isOpaqueContractCall
                  ? getOpaqueContractDisplayName(transaction)
                  : getContractDisplayName(transaction)}
              </span>
              {/* Case: decoded calls have function metadata to display. */}
              {!isOpaqueContractCall ? (
                <>
                  <ArrowRight className="mx-1 h-3 w-3 shrink-0" />
                  <span className="min-w-0 truncate font-normal text-sm">
                    {transaction.functionName}
                  </span>
                </>
              ) : null}
            </span>
          </div>
        ) : null}
        <span className="block max-w-full truncate text-xs font-normal text-muted-foreground">
          {transaction.description}
        </span>
      </div>
    </div>
  );
}
